export var CustomListKey;
(function (CustomListKey) {
    CustomListKey["ClientStatus"] = "ClientStatus";
})(CustomListKey || (CustomListKey = {}));
//# sourceMappingURL=custom-list.js.map